/**
 * Created by chachora on 06/04/19.
 */

import React, { PureComponent } from 'react';
import withStyles from '@mui/styles/withStyles';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import CalendarToday from '@mui/icons-material/CalendarToday';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import { withTranslation } from 'react-i18next';

class CalendarViews extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isDropdownOpen: true,
    };
  }

  handleDropdownToggle = () => {
    this.setState({
      isDropdownOpen: !this.state.isDropdownOpen,
    });
  };

  handleChange = view => {
    const { onChange } = this.props;
    if (onChange) onChange(view);
  };

  render() {
    const { view, views, classes, t } = this.props;
    return (
      <>
        <ListItemButton onClick={this.handleDropdownToggle}>
          <ListItemIcon>
            <CalendarToday />
          </ListItemIcon>
          <ListItemText>{t('Calendar')}</ListItemText>
          {this.state.isDropdownOpen ? (
            <ExpandLess className={classes.expandIcon} />
          ) : (
            <ExpandMore className={classes.expandIcon} />
          )}
        </ListItemButton>
        <Collapse in={this.state.isDropdownOpen}>
          <List dense disablePadding>
            {Object.keys(views).map(v => (
              <ListItemButton
                key={v}
                selected={view === v}
                onClick={this.handleChange.bind(this, v)}
              >
                <ListItemText inset>{v.toUpperCase()}</ListItemText>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      </>
    );
  }
}

const styles = theme => ({
  expandIcon: {
    color: theme.palette.text.secondary,
  },
});

export default withTranslation()(withStyles(styles)(CalendarViews));
